import type * as lazyIndex from './lazyIndex';
import { startSearch } from 'owa-search-actions/lib/actions/startSearch';
import { setSearchText } from 'owa-search-actions/lib/actions/setSearchText';
import { exitSearch } from 'owa-search-actions/lib/actions/exitSearch';
import { LazyModule, LazyImport, LazyAction, registerLazyOrchestrator } from 'owa-bundling';
import onCloseSearch from './actions/onCloseSearch';
import onOpenMetaOsApp from 'owa-app-host-state/lib/actions/onOpenMetaOsApp';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AppHostSearch" */ './lazyIndex'),
    { name: 'AppHostSearch' }
);

export { default as onAppHostHeaderStartSearch } from './actions/onAppHostHeaderStartSearch';

export { onAppAddSearchEventListenerMutator } from './actions/onAppAddSearchEventListener';
export { onAppClearSearchListenersMutator } from './actions/onAppClearSearchListeners';
export const lazyOnCloseSearch: LazyAction<typeof lazyIndex.onCloseSearch, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.onCloseSearch);

export const lazyShouldUseAppHostSearch: LazyImport<
    typeof lazyIndex.shouldUseAppHostSearch,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.shouldUseAppHostSearch);

// AppHost orchestrators
registerLazyOrchestrator(startSearch, lazyModule, m => m.startSearchOrchestrator);
registerLazyOrchestrator(setSearchText, lazyModule, m => m.setSearchTextOrchestrator);
registerLazyOrchestrator(exitSearch, lazyModule, m => m.exitSearchOrchestrator);
registerLazyOrchestrator(onCloseSearch, lazyModule, m => m.closeSearchOrchestrator);
registerLazyOrchestrator(
    onOpenMetaOsApp,
    lazyModule,
    m => m.exitSearchOnOpenLaunchPageOrchestrator
);

import './mutators/searchEventRegistrationsMutators';
